// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_jt-0";
export var discountCodeInput = "_jt-1";